var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgGift = function SvgGift(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1729_2135",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 23,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24.6042V10.8149L22.4824 10.8149V24.6042H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1729_2135)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1994 24.6042L1.25685 24.5648C0.561389 24.5634 -0.00127185 23.9985 2.15923e-06 23.3029L0.0214354 12.072C0.0227844 11.3764 0.587618 10.8136 1.28307 10.8149L21.2256 10.8543C21.9211 10.8557 22.4838 11.4206 22.4824 12.1162L22.461 23.3471C22.4597 24.0427 21.8948 24.6055 21.1994 24.6042Z",
    fill: "#8246FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4737 16.8594L0.0126953 16.8152L0.0183909 13.8169L22.4794 13.8611L22.4737 16.8594Z",
    fill: "#5A1ED7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9954 22.5426C16.9052 22.5621 16.8118 22.5728 16.7161 22.5726C16.0043 22.5713 15.4274 21.9901 15.4287 21.2748C15.4301 20.5607 16.0093 19.9818 16.7211 19.9832C16.8167 19.9834 16.9101 19.9944 17.0002 20.0143C16.6313 20.3112 16.3936 20.7664 16.3926 21.2767C16.3916 21.7881 16.6276 22.2443 16.9954 22.5426Z",
    fill: "#5A1ED7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3007 21.2822C19.2994 21.9975 18.7201 22.5765 18.0072 22.5751C17.7725 22.5746 17.5521 22.511 17.3621 22.4005C16.9768 22.1752 16.7179 21.7571 16.7188 21.2774C16.7197 20.7987 16.9801 20.3816 17.3664 20.1577C17.5567 20.0479 17.7775 19.9851 18.0122 19.9856C18.7251 19.987 19.3021 20.5681 19.3007 21.2822Z",
    fill: "#5A1ED7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0735 22.142L2.12209 22.1269C1.8816 22.1264 1.68705 21.9311 1.6875 21.6906L1.6896 20.5989C1.69005 20.3584 1.88535 20.1639 2.12583 20.1643L10.0772 20.1795C10.3176 20.1799 10.5122 20.3753 10.5118 20.6158L10.5097 21.7074C10.5092 21.9479 10.3139 22.1425 10.0735 22.142Z",
    fill: "#5A1ED7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9759 16.3607L6.00351 16.3188C5.09095 16.3169 4.3527 15.5761 4.3545 14.6641L4.3763 3.63672C4.3781 2.72453 5.1195 1.98658 6.03213 1.98853L26.0046 2.03035C26.9171 2.03237 27.6553 2.77309 27.6535 3.68505L27.6318 14.7125C27.6299 15.6247 26.8886 16.3626 25.9759 16.3607Z",
    fill: "url(#paint0_linear_1729_2135)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.647 6.97463L4.36914 6.92726L4.37364 4.72241L27.6515 4.7697L27.647 6.97463Z",
    fill: "#FCCF3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74707 16.3238L8.77622 1.99219L10.9765 1.99661L10.9474 16.3283L8.74707 16.3238Z",
    fill: "#FCCF3D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1613 4.73411L14.2777 4.74048C14.8815 4.74175 15.3736 4.25051 15.3749 3.64551C15.3761 3.04043 14.886 2.54724 14.2822 2.54604H14.2666C12.8381 2.54312 11.6174 3.45771 11.1613 4.73411ZM14.2732 6.94529L9.86743 6.93637C9.25988 6.9351 8.76833 6.44056 8.76953 5.83166C8.77568 2.79803 11.2437 0.334931 14.2711 0.341076L14.2867 0.341151C16.1037 0.344823 17.5788 1.82911 17.5752 3.64989C17.5714 5.47067 16.0903 6.94904 14.2732 6.94529Z",
    fill: "#FCC419"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1729_2135",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 9,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9695 0.323242H2.17285L2.17285 6.93637H10.9695V0.323242V0.323242Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1729_2135)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46925 2.5281C4.86545 2.5269 4.37331 3.01807 4.37211 3.62314C4.37091 4.22815 4.86103 4.72133 5.46476 4.72253L8.5812 4.7289C8.13028 3.45063 6.9133 2.53102 5.48484 2.52817L5.46925 2.5281ZM9.86612 6.93638L5.46031 6.92739C3.64336 6.92372 2.16821 5.43943 2.17188 3.61872C2.17555 1.79787 3.65677 0.319577 5.4738 0.323249L5.48939 0.323324C8.5168 0.329469 10.9747 2.80254 10.9685 5.83624C10.9673 6.44507 10.4737 6.93766 9.86612 6.93638Z",
    fill: "#FCC419"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7297 10.8132C13.4485 10.8126 13.1678 10.7048 12.9534 10.4896L9.07156 6.59328C8.6423 6.16244 8.6429 5.46444 9.07284 5.03428C9.50278 4.60396 10.1993 4.60456 10.6288 5.03547L14.5106 8.93183C14.9399 9.36274 14.9393 10.0607 14.5092 10.4909C14.2939 10.7063 14.0117 10.8138 13.7297 10.8132Z",
    fill: "#FCC419"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98956 10.7975C5.70755 10.797 5.42585 10.6884 5.21129 10.4721C4.78307 10.0402 4.78532 9.34223 5.21638 8.91304L9.11394 5.03249C9.54508 4.60338 10.2416 4.6057 10.6699 5.03759C11.0981 5.46948 11.0958 6.16756 10.6649 6.59659L6.76722 10.4772C6.55207 10.6914 6.27059 10.7981 5.98956 10.7975Z",
    fill: "#FCC419"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0005 20.1079C32.0005 24.2881 28.6117 27.677 24.4314 27.677C20.2511 27.677 16.8623 24.2881 16.8623 20.1079C16.8623 15.9277 20.2511 12.5388 24.4314 12.5388C28.6117 12.5388 32.0005 15.9277 32.0005 20.1079Z",
    fill: "#FCC419"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4699 20.1078C30.4699 23.4431 27.7661 26.1469 24.4308 26.1469C21.0954 26.1469 18.3916 23.4431 18.3916 20.1078C18.3916 16.7724 21.0954 14.0686 24.4308 14.0686C27.7661 14.0686 30.4699 16.7724 30.4699 20.1078Z",
    fill: "#FFD43B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7268 18.4475C25.5526 18.5507 25.329 18.5104 25.1987 18.3555C25.1347 18.2793 25.0722 18.2235 25.0113 18.1879C24.8845 18.1069 24.7211 18.0663 24.5209 18.0663C24.2751 18.0663 24.0711 18.136 23.9089 18.2753C23.7467 18.412 23.6656 18.5845 23.6656 18.7923C23.6656 19.0786 23.8785 19.3092 24.3042 19.4841L24.8897 19.7234C25.366 19.9162 25.7145 20.1511 25.935 20.4286C26.1554 20.7061 26.2656 21.0464 26.2656 21.4493C26.2656 21.9891 26.0857 22.435 25.7259 22.7872C25.3635 23.142 24.9137 23.3194 24.3765 23.3194C23.8672 23.3194 23.4464 23.1686 23.1145 22.8672C22.8945 22.6641 22.7302 22.4054 22.6214 22.0911C22.5325 21.8338 22.6823 21.5541 22.9482 21.4955C23.1848 21.4434 23.4126 21.5905 23.4802 21.8231C23.5162 21.947 23.5604 22.0429 23.6124 22.1105C23.7948 22.3641 24.061 22.4907 24.4106 22.4907C24.6869 22.4907 24.9162 22.3982 25.0987 22.2133C25.2811 22.0283 25.3724 21.7938 25.3724 21.5101C25.3724 21.3961 25.3565 21.2915 25.3248 21.1965C25.2932 21.1015 25.2437 21.014 25.1766 20.9343C25.1095 20.8543 25.0226 20.7797 24.9162 20.7098C24.8098 20.6403 24.683 20.5737 24.536 20.5104L23.9698 20.2748C23.1665 19.9351 22.7648 19.4385 22.7648 18.7846C22.7648 18.3438 22.9333 17.975 23.2704 17.6785C23.6073 17.3795 24.0268 17.23 24.5285 17.23C25.0463 17.23 25.4773 17.423 25.8215 17.8089C25.9966 18.0053 25.9531 18.3133 25.7268 18.4475Z",
    fill: "#F08C00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4308 24.2124C24.174 24.2124 23.9658 24.0042 23.9658 23.7475V23.2196C23.9658 22.9628 24.174 22.7546 24.4308 22.7546C24.6875 22.7546 24.8957 22.9628 24.8957 23.2196V23.7475C24.8957 24.0042 24.6875 24.2124 24.4308 24.2124Z",
    fill: "#F08C00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4308 17.8193C24.174 17.8193 23.9658 17.6111 23.9658 17.3544V16.8265C23.9658 16.5698 24.174 16.3616 24.4308 16.3616C24.6875 16.3616 24.8957 16.5698 24.8957 16.8265V17.3544C24.8957 17.6111 24.6875 17.8193 24.4308 17.8193Z",
    fill: "#F08C00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_2135",
    x1: 3.50098,
    y1: 4,
    x2: 27.001,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8246FF"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgGift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gift.d7ea290d353c301fcb4c1760b8543058.svg";